import { useTranslation } from 'react-i18next';
import { useImpersonate } from '@contexts/ImpersonateContext.tsx';

export function ImpersonationBanner() {
  const { t } = useTranslation('component', {
    keyPrefix: 'impersonationBanner',
  });
  const { isImpersonating } = useImpersonate();

  if (!isImpersonating) {
    return null;
  }

  return (
    <div
      className="bg-yellow-100 border-l-4 border-ivarioYellow text-black p-4 mb-4"
      data-testid="ImpersonationBannerComponent"
    >
      <div className="flex">
        <div className="ml-3">
          <p className="text-md font-medium">{t('message')}</p>
        </div>
      </div>
    </div>
  );
}
